import {useEffect, useState} from "react";
import {useNavigate, useOutletContext} from "react-router-dom";
import {useAuth} from "base/user/provider";

import {EntityViewSubPage} from "base/entity/components/container";
import {
    EntityAuditSection,
    EntityCommentsSection,
} from "base/entity/components/presentational/sections";
import {DeleteEntityButton, DeleteItemDialog} from "base/delete/components";
import {PermitExtensionService} from "permitextension/service";
import {PermitExtensionGeneralDataSection} from "permitextension/presentational";

const ViewPermitExtensionSummarySubPage = () => {
    const context = useOutletContext();
    const element = context[0];
    const auth = useAuth();
    const navigate = useNavigate();

    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [deletionError, setDeletionError] = useState(null);

    const allowDelete = auth.hasPermission("delete-permitapplications");

    useEffect(() => {
        setDeletionError(null);
    }, []);

    const handleDelete = () => {
        PermitExtensionService.delete(element.id)
            .then(() => {
                navigate("/permits/extensions/list");
            })
            .catch(error => {
                console.log(error);
                setDeletionError(error);
            });
    };

    const sections = [
        <PermitExtensionGeneralDataSection element={element} key="generaldata" />,
        <EntityCommentsSection
            key="comments"
            comments={element?.comments}
            title="Observações da Secretaria"
            displayCard
        />,
        <EntityAuditSection entity={element} key="audit" />,
    ];

    return (
        element && (
            <EntityViewSubPage sections={sections}>
                {allowDelete ? (
                    <>
                        <DeleteEntityButton
                            openDialog={() => setIsDeleteDialogOpen(true)}
                            entityName={"prorrogação"}
                        />
                        <DeleteItemDialog
                            isDialogOpen={isDeleteDialogOpen}
                            setIsDialogOpen={setIsDeleteDialogOpen}
                            deletionError={deletionError}
                            onDelete={handleDelete}
                        />
                    </>
                ) : null}
            </EntityViewSubPage>
        )
    );
};

export default ViewPermitExtensionSummarySubPage;
